import React, { Component } from 'react';
import { FaLinkedinIn,FaGithub,FaFileAlt,FaQrcode } from 'react-icons/fa';

import { MdMenu,MdEmail } from "react-icons/md";

import { BsFileEarmarkPersonFill } from "react-icons/bs";

class nav extends Component {

    constructor(props) {
        super(props);
        this.toogleNav = this.toogleNav.bind(this);
        this.isCollaped=false;
        this.state = { height:'0px'};
      }

      toogleNav(){
      if(!this.isCollaped){
        this.setState({
          height:'100vh'
        });      }
      else{
        this.setState({
          height:'0px'
        });

      }
      this.isCollaped=!this.isCollaped;

      }
      //like view mounted
      componentDidMount() {}
    
    render() {
    const mystyle = {
      transition: "0.8s",
      maxHeight: this.state.height
    };
      return <div className='leftNav'>
        <div className='navCollaps'>
          <MdMenu onClick={this.toogleNav} className='collapsIcon'/>
          <p className='navName'>Zhyar A. Jamal</p>
        </div>
        <div id="navigation" style={mystyle} className="navContent">
        <img alt='navPhoto' className='navPhoto' src={process.env.PUBLIC_URL+"/Photo/3.jpg"}/>
        <div className='navDescripton'>
        Hi, my name is Zhyar Aballah Jamal and I'm a software engineer. Welcome to my Personal website!
        </div>

<div className='navIcons'>
<FaLinkedinIn style={{ "cursor":"pointer" }} onClick={()=>window.open("https://www.linkedin.com/in/zhyar-abdulla-3a0b13116/","_blank")} />
<FaGithub style={{ "cursor":"pointer" }}  onClick={()=>window.open("https://github.com/zhiar97","_blank")}/>
</div>
<hr className='divider'/>
<div className='navMenu'>
<ul>
  <li onClick={()=>window.location.href="#about"}><div className='menuIcon'><BsFileEarmarkPersonFill className='menuIconSvg'/></div><span>About Me</span></li>
  <li onClick={()=>window.location.href="#portfolio"}><div className='menuIcon'><FaQrcode className='menuIconSvg'/></div><span>Portfolio</span></li>
  <li onClick={()=>window.open("/resume.pdf","_blank")}><div className='menuIcon'><FaFileAlt className='menuIconSvg'/></div><span>Resume</span></li>
  <li onClick={()=>window.location.href="#contact"}><div className='menuIcon'><MdEmail className='menuIconSvg'/></div><span>Contact</span></li>

</ul>
</div>
        </div>
      </div>
    }
  }

  export default nav;
